import { Box, BoxProps, Typography, useTheme } from '@mui/material';
import { ColumnBoxFlexFullWidth } from './boxes';

interface IProps extends BoxProps {
  title: string;
  borderStyle?: 'solid' | 'dotted';
  titleColor?: string;
}

export const BorderBoxWithTitle = ({ title, titleColor, children, borderStyle = 'solid', ...props }: IProps) => {
  const theme = useTheme();
  return (
    <ColumnBoxFlexFullWidth position={'relative'} border={`1px ${borderStyle} ${theme.palette.grey.A400}`}
                            borderRadius={theme.shape.borderRadius} mt={2} p={2} {...props}
    >
      <Box position={'absolute'} top={-12} px={1}
           sx={{ background: '#fff', left: '50%', transform: 'translate(-50%)' }}>
        <Typography sx={{ color: titleColor || theme.palette.primary.main }} noWrap>
          {title}
        </Typography>
      </Box>
      {children}
    </ColumnBoxFlexFullWidth>
  );
};